/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class Viewer3dController implements angular.IController {

        $onInit = () => { };
        constructor(private forgeService: ForgeService, private $routeParams: any, private $timeout: ng.ITimeoutService) {
            var vm = this;
            var viewer;

            /**
            * Autodesk.Viewing.Document.load() success callback.
            * Proceeds with model initialization.
            */
            function onDocumentLoadSuccess(doc) {

                // A document contains references to 3D and 2D viewables.
                var viewables = Autodesk.Viewing.Document.getSubItemsWithProperties(doc.getRootItem(), { 'type': 'geometry' }, true);
                if (viewables.length === 0) {
                    console.error('Document contains no viewables.');
                    return;
                }

                // Choose any of the avialble viewables
                var initialViewable = viewables[0];
                var svfUrl = doc.getViewablePath(initialViewable);
                var modelOptions = {
                    sharedPropertyDbPath: doc.getPropertyDbPath()
                };

                var viewerDiv = document.getElementById('viewport');
                viewer = new Autodesk.Viewing.Private.GuiViewer3D(viewerDiv);
                viewer.start(svfUrl, modelOptions, onLoadModelSuccess, onLoadModelError);
            }

            function destroy() {
                if (viewer != null) {
                    viewer.finish();
                }
            }

            /**
             * Autodesk.Viewing.Document.load() failuire callback.
             */
            function onDocumentLoadFailure(viewerErrorCode) {
                console.error('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
            }

            /**
             * viewer.loadModel() success callback.
             * Invoked after the model's SVF has been initially loaded.
             * It may trigger before any geometry has been downloaded and displayed on-screen.
             */
            function onLoadModelSuccess(model) {
                console.log('onLoadModelSuccess()!');
                console.log('Validate model loaded: ' + (viewer.model === model));
                console.log(model);
            }

            /**
             * viewer.loadModel() failure callback.
             * Invoked when there's an error fetching the SVF file.
             */
            function onLoadModelError(viewerErrorCode) {
                console.error('onLoadModelError() - errorCode:' + viewerErrorCode);
            }

            var options = {
                env: 'AutodeskProduction',
                getAccessToken: (onGetAccessToken) => {
                    vm.forgeService.getAccessToken().then((token: string) => {
                        var accessToken = token;
                        onGetAccessToken(accessToken, 86400);
                    });
                }
            };
            vm.$timeout(() => {
                var documentId = 'urn:' + $routeParams.objectId.replace(/={1,2}$/, '');
                Autodesk.Viewing.Initializer(options, function onInitialized() {
                    Autodesk.Viewing.Document.load(documentId, onDocumentLoadSuccess, onDocumentLoadFailure);
                });
            }, 1000);   
        }

    }

    Viewer3dController.$inject = ['ForgeService', '$routeParams', '$timeout'];

    angular
        .module('eseebase')
        .controller('Viewer3dController', Viewer3dController);
}
